import Vue, { RenderContext } from 'vue';
import { mergeData } from 'vue-functional-data-merge';

export const props = {
    tag: {
        type: String,
        default: 'div'
    },
    noGutters: {
        type: [Boolean, String],
        default: false
    },
    justifyStart: {
        type: [Boolean, String],
        default: false
    },
    justifyCenter: {
        type: [Boolean, String],
        default: false
    },
    justifyEnd: {
        type: [Boolean, String],
        default: false
    },
    justifyBetween: {
        type: [Boolean, String],
        default: false
    },
    justifyAround: {
        type: [Boolean, String],
        default: false
    }
};

export const TRow = Vue.extend({
    name: 'TRow',
    functional: true,
    props,
    render(h: any, { props, children, data }: RenderContext) {
        return h(
            props.tag,
            mergeData(data, {
                class: {
                    row: !(props.noGutters || props.noGutters === ''),
                    'row --no-gutters': props.noGutters === true || props.noGutters === '',
                    'justify-content-start': props.justifyStart === true || props.justifyStart === '',
                    'justify-content-center': props.justifyCenter === true || props.justifyCenter === '',
                    'justify-content-end': props.justifyEnd === true || props.justifyEnd === '',
                    'justify-content-between': props.justifyBetween === true || props.justifyBetween === '',
                    'justify-content-around': props.justifyAround === true || props.justifyAround === ''
                }
            }),
            children
        );
    }
});
